export type LappMeta = {
  appId: string;
  version: string;
};

export async function extractLappMeta(file: File): Promise<LappMeta> {
  const buffer = await file.arrayBuffer();
  const bytes = new Uint8Array(buffer);
  const view = new DataView(buffer);
  const cd = findCentralDirectory(view);
  let offset = cd.offset;

  for (let i = 0; i < cd.totalEntries; i += 1) {
    if (view.getUint32(offset, true) !== 0x02014b50) {
      throw new Error("Central directory của .lapp không hợp lệ.");
    }

    const compressionMethod = view.getUint16(offset + 10, true);
    const compressedSize = view.getUint32(offset + 20, true);
    const fileNameLength = view.getUint16(offset + 28, true);
    const extraLength = view.getUint16(offset + 30, true);
    const commentLength = view.getUint16(offset + 32, true);
    const localHeaderOffset = view.getUint32(offset + 42, true);
    const fileName = decodeText(bytes.slice(offset + 46, offset + 46 + fileNameLength));

    if (fileName === "manifest.json") {
      const localNameLength = view.getUint16(localHeaderOffset + 26, true);
      const localExtraLength = view.getUint16(localHeaderOffset + 28, true);
      const dataStart = localHeaderOffset + 30 + localNameLength + localExtraLength;
      const raw = bytes.slice(dataStart, dataStart + compressedSize);
      const jsonText = await unzipMember(raw, compressionMethod);
      const manifest = JSON.parse(jsonText) as { app_id?: string; version?: string };
      if (!manifest.app_id || !manifest.version) {
        throw new Error("manifest.json thiếu app_id hoặc version.");
      }
      return { appId: manifest.app_id, version: manifest.version };
    }

    offset += 46 + fileNameLength + extraLength + commentLength;
  }

  throw new Error("Không tìm thấy manifest.json trong .lapp.");
}

function findCentralDirectory(view: DataView): { offset: number; totalEntries: number } {
  for (let offset = view.byteLength - 22; offset >= 0; offset -= 1) {
    if (view.getUint32(offset, true) !== 0x06054b50) {
      continue;
    }
    return {
      totalEntries: view.getUint16(offset + 10, true),
      offset: view.getUint32(offset + 16, true),
    };
  }
  throw new Error("Không đọc được central directory của .lapp.");
}

async function unzipMember(data: Uint8Array, compressionMethod: number): Promise<string> {
  if (compressionMethod === 0) {
    return decodeText(data);
  }
  if (compressionMethod !== 8) {
    throw new Error(`.lapp dùng compression method ${compressionMethod} chưa được hỗ trợ.`);
  }
  if (typeof DecompressionStream === "undefined") {
    throw new Error("Trình duyệt hiện tại không hỗ trợ đọc .lapp cục bộ.");
  }
  const rawBuffer = new ArrayBuffer(data.byteLength);
  new Uint8Array(rawBuffer).set(data);
  const stream = new Blob([rawBuffer]).stream().pipeThrough(new DecompressionStream("deflate-raw"));
  const decompressed = await new Response(stream).arrayBuffer();
  return decodeText(new Uint8Array(decompressed));
}

function decodeText(bytes: Uint8Array): string {
  return new TextDecoder("utf-8").decode(bytes);
}
